import { Tabs } from "antd";
import type { TabsProps } from "antd";
import styles from "./style";
import OnePointLesson from "./OnePointLesson";
import CorrectiveAction from "./CorrectiveAction";

type props = {
  formdata?: any;
  setformdata?: any;
  readMode?: any;
};

const OutcomeAdvanceMainPage = ({ formdata, setformdata, readMode }: props) => {
  const classes = styles();
  const items: TabsProps["items"] = [
    {
      key: "1",
      label: "Corrective Action",
      children: (
        <CorrectiveAction
          formdata={formdata}
          setformdata={setformdata}
          readMode={readMode}
        />
      ),
    },
    {
      key: "2",
      label: "One Point Lesson",
      children: (
        <OnePointLesson
          formdata={formdata}
          setformdata={setformdata}
          readMode={readMode}
        />
      ),
    },
  ];
  return (
    <div className={classes.mainPageContainer}>
      <div className={classes.tabContainer}>
        <Tabs
          defaultActiveKey="1"
          type="card"
          items={items}
          className={classes.tabsWrapper}
          tabBarStyle={{ display: "flex", justifyContent: "center" }}
        />
      </div>
    </div>
  );
};

export default OutcomeAdvanceMainPage;
